function RotateInfoContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative grid h-full w-full grid-rows-[min-content_1fr_min-content]">
      {children}
    </div>
  )
}

export { RotateInfoContainer }
